import { render } from "./crew.vue?vue&type=template&id=2bfbd825&scoped=true"
import script from "./crew.vue?vue&type=script&lang=js"
export * from "./crew.vue?vue&type=script&lang=js"

import "./crew.vue?vue&type=style&index=0&id=2bfbd825&lang=css&scoped=true"

import exportComponent from "/var/www/mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfbd825"]])

export default __exports__